import { ColDef, ICellRendererParams } from "ag-grid-community";
import { Location } from "../../../models/CatLocation";
import { useLocationContext } from "../LocationContext";
import { CheckboxRenderer } from "@/controls/ag-grid/components/CheckboxRenderer";
import { GridButtonsV2 } from "@/controls/buttons/GridButtonsV2";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  setLocation: (location: Location | null) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  showContextMenu: Function;
};

export const useTableData = ({
  setLocation,
  setShowModal,
  showContextMenu,
}: Props) => {
  const { state } = useLocationContext();

  const rows: Location[] =
    state.locations?.map((location: Location) => ({
      ...location,
    })) || [];

  const columnDefs: ColDef[] = [
    {
      headerName: "Name",
      field: "Name",
      flex: 1,
      sortable: true,
      filter: true,
      resizable: true,
    },
    // {
    //   field: "-",
    //   cellRenderer: GridButtonsV2,
    //   cellRendererParams: (params: ICellRendererParams) => ({
    //     setData: setLocation,
    //     data: params.data as Location,
    //     setShowModal: setShowModal,
    //     edit: false,
    //     del: true,
    //     showContextMenu: () =>
    //       showContextMenu(event, params.data, "locationContext"),
    //   }),
    //   headerName: "",
    //   sortable: false,
    //   minWidth: 150,
    //   filter: false,
    // },
  ];

  return { rows, columnDefs };
};
